import React, { useCallback } from 'react';
import {
  StyleSheet, View, Text, Image,
} from 'react-native';
import { TapGestureHandler, State } from 'react-native-gesture-handler';
import { ActivityIndicator } from 'react-native-paper';

import { useColors } from '../../contexts/theme';
import WeightDot from '../WeightDot';
import ActionsMenu from './ActionsMenu';


const styles = StyleSheet.create({
  itemText: {
    textAlign: 'left',
    justifyContent: 'flex-start',
  },
  title: {
    fontWeight: 'bold',
    // fontSize: 13,
  },
  container: {
    flex: 1, width: '100%', flexDirection: 'row', height: '100%', alignItems: 'center', padding: 10,
  },
  wrapper: {
    flexDirection: 'row', width: '100%', height: '100%', alignItems: 'center',
  },
  weightDot: { width: 30, height: 30, marginRight: 10 },
  image: {
    width: 30, height: 30, borderRadius: 5, marginRight: 10,
  },
  activityIndicator: { width: 30, height: 30, marginRight: 10 },
  flexOne: {
    flex: 1,
  },
});

const titleWithMultilineDots = (title) => {
  if (!title) {
    return null;
  }
  const explicitRows = title.split('\n');

  return explicitRows.length > 1
    ? `${explicitRows[0]} ..`
    : title;
};

const SimpleDetail = ({
  actions,
  dotColor,
  dotWeight,
  image,
  loadingMetadata,
  onPress,
  subtitle,
  time,
  title,
}) => {
  const colors = useColors(),
        onHandlerStateChange = useCallback(({ nativeEvent }) => {
          if (nativeEvent.state === State.ACTIVE) {
            onPress();
          }
        }, [onPress]);

  return (
    <View style={styles.wrapper}>
      <TapGestureHandler
        maxDurationMs={200}
        onHandlerStateChange={onHandlerStateChange}
      >
        <View style={styles.container}>
          { dotColor && dotWeight ? (
            <WeightDot
              weight={dotWeight}
              color={dotColor}
              containerStyle={styles.weightDot}
            />
          ) : null }
          { image ? (
            <Image
              source={{ uri: image, width: 30, height: 30 }}
              style={styles.image}
              resizeMode='cover'
            />
          ) : loadingMetadata ? <ActivityIndicator style={styles.activityIndicator} /> : null }

          <View style={styles.flexOne}>
            <Text
              style={[styles.title, { color: colors.text }]}
              numberOfLines={1}
            >
              { titleWithMultilineDots(title) }
            </Text>
            { subtitle ? (
              <Text
                style={[styles.itemText, { color: colors.text }]}
                numberOfLines={1}
              >
                { subtitle }
              </Text>
            ) : null }
            { time ? (
              <Text
                style={[styles.itemText, { color: colors.text }]}
                numberOfLines={1}
              >
                { time }
              </Text>
            ) : null }
          </View>
        </View>
      </TapGestureHandler>
      <ActionsMenu actions={actions} />
    </View>
  );
};

export default SimpleDetail;
